var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-shell"},[_c('p',{staticClass:"chart-shell-title"},[_vm._v(_vm._s(_vm.title)+"：")]),_c('p',{staticClass:"chart-shell-info"},[_vm._v(_vm._s(_vm.info))]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }